module.exports = __webpack_public_path__ + "media/images/area/maps/hokkaido-region-93a05d1f8bfef943de6342d51ad44775.svg";